/**
 *  @class
 *  @function MediaWithTabs
 */
if (!customElements.get('media-with-tabs')) {
  class MediaWithTabs extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('.media-with-tabs--button'));
      this.slider = this.querySelector('slide-show');
      
      // Inicializar botones
      this.buttons.forEach((button, i) => {
        button.addEventListener('click', () => {
          this.buttonClick(button, i);
        });
      });
      
      // NUEVO: Reinicializar cuando las imágenes estén cargadas
      this.initializeSlider();
      
      // NUEVO: Reinicializar después de un breve retraso como respaldo
      setTimeout(() => this.resizeSlider(), 100);
    }
    
    // NUEVO: Método para inicializar correctamente el slider
    initializeSlider() {
      if (!this.slider) return;
      
      // Esperar a que las imágenes estén cargadas
      window.addEventListener('load', () => this.resizeSlider());
      
      // También observar si hay cambios en el tamaño
      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => this.resizeSlider());
        resizeObserver.observe(this.slider);
      }
    }
    
    // NUEVO: Método para forzar el recálculo del slider
    resizeSlider() {
      if (!this.slider) return;
      
      const flkty = Flickity.data(this.slider);
      if (flkty) {
        flkty.resize();
        flkty.reloadCells();
        
        // Mostrar la primera slide con la clase active ya establecida
        const activeTab = this.querySelector('.media-with-tabs--tab.active');
        if (activeTab) {
          const index = this.buttons.indexOf(activeTab.querySelector('.media-with-tabs--button'));
          if (index >= 0) flkty.select(index);
        }
      }
    }
    
    buttonClick(button, i) {
      let flkty = Flickity.data(this.slider);
      [].forEach.call(this.buttons, function (el) {
        el.parentElement.classList.remove('active');
      });
      button.parentElement.classList.add('active');

      flkty.select(i);
    }
  }
  customElements.define('media-with-tabs', MediaWithTabs);
}